// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3vpZy","cell":"ColumnAccessor_cell__3ZsHM","firstCellAccent":"ColumnAccessor_firstCellAccent__1_t7m"};